import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { useReveal } from "../../lib/motion";

export default function Manifesto() {
  const copy = useReveal();

  return (
    <section className="section section--defer mani">
      <div className="wrap wrap--wide mani__grid">
        <div className="mani__media">
          <Photo src="salon-01" ratio="4 / 5" scrub className="mani__photo" tint="warm" />
          <Photo src="salon-02" ratio="1 / 1" scrub className="mani__photo mani__photo--inset" />
        </div>

        <div className="mani__copy reveal" ref={copy}>
          <span className="eyebrow eyebrow--violet">THE HOUSE</span>

          <h2 className="mani__title">
            یک سالن، نه یک
            <span className="mani__em"> فروشگاه</span>
          </h2>

          <p className="mani__lede">
            رُز جایی است که نتیجه از مشاوره شروع می‌شود. اینجا چیزی به تو
            فروخته نمی‌شود؛ وقت گذاشته می‌شود تا بفهمیم مو و پوستت چه
            می‌خواهد و بعد کار شروع می‌شود.
          </p>

          <ul className="mani__list">
            <li>هر خدمت را متخصصِ همان حوزه انجام می‌دهد</li>
            <li>ابزار برای هر مراجعه استریل و اختصاصی است</li>
            <li>قیمت پیش از شروع نهایی می‌شود و تغییر نمی‌کند</li>
            <li>پیگیری هفته اول بعد از هر خدمت</li>
          </ul>

          <Link to="/staff" className="tlink">
            آشنایی با تیم<span className="tlink__arrow">←</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
